import { render } from "./AddNewLoan.vue?vue&type=template&id=09dffd17&scoped=true"
import script from "./AddNewLoan.vue?vue&type=script&lang=js"
export * from "./AddNewLoan.vue?vue&type=script&lang=js"

import "./AddNewLoan.vue?vue&type=style&index=0&id=09dffd17&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dffd17"]])

export default __exports__